module.exports = __webpack_public_path__ + "static/media/batteryRed.3ff37a02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DevicesList/batteryRed.svg
// module id = 162
// module chunks = 0